// Products that go through the Cart Transform test flow instead of the PMS
// draft order. Add or remove product handles here; nothing else needs to change.
export const CART_TRANSFORM_PRODUCT_HANDLES = [
    "seal-skin-pristine-chair-cover-model-4", // Two Seater Patio Couch Covers
    "generator-covers", // Generator Covers
    "rectangular-outdoor-custom-covers", // Custom Rectangular Covers
    "seal-skin-pristine-umbrella-cover", // Custom Umbrella Covers
    "seal-skin-pristine-dining-table-cover-model-4", // Rectangular Table Set Covers
    "seal-skin-pristine-rectangle-accent-cover", // Custom Rectangle Table Accent Covers
    "custom-square-rectangle-covers", // Custom Square/Rectangle Covers
    "custom-tv-covers", // Outdoor TV Covers
    "seal-skin-pristine-round-table-cover-model-2", // Round Patio Table Covers
    "outdoor-air-conditioner-covers", // Outdoor AC Unit Covers
];

// Line attribute that marks a cart line as using the Cart Transform flow.
export const CART_TRANSFORM_FLAG = "_cart_transform";

export const isCartTransformHandle = (handle) => CART_TRANSFORM_PRODUCT_HANDLES.includes(handle);

export const isCartTransformLine = (item) => (item?.node?.attributes || [])
    .some((attr) => attr.key === CART_TRANSFORM_FLAG && attr.value === "Yes");
